import { Dispatch, FC, SetStateAction } from 'react';

import { GammaTeamRole, selectableGammaTeamRoles } from '@/api/gamma-team/types';
import { EMAIL_REGEX } from '@/constants/static';
import { Input, Select } from '@/shared/design-system';

import { TeamMemberFields } from '../team-member-fields.styled';
import { GammaTeamMemberAddData } from './index';

interface GammaTeamMemberAddFormProps {
  data: GammaTeamMemberAddData;
  setData: Dispatch<SetStateAction<GammaTeamMemberAddData>>;
  resError?: string;
}

export const GammaTeamMemberAddForm: FC<GammaTeamMemberAddFormProps> = ({
  data,
  setData,
  resError,
}) => {
  const invalidEmail = !EMAIL_REGEX.test(data.email) && data.email.length > 1;
  const emailError = resError || (invalidEmail ? 'Invalid email' : undefined);

  return (
    <TeamMemberFields>
      <Input
        size="lg"
        label="Email"
        required
        placeholder="Enter email"
        value={data.email}
        state={emailError ? 'destructive' : undefined}
        helperText={emailError}
        onChange={(event) => setData((prev) => ({ ...prev, email: event.target.value }))}
      />

      <Select
        size="lg"
        label="Role"
        required
        placeholder="Select role"
        options={selectableGammaTeamRoles}
        value={data.role || null}
        onChange={(role) => setData((prev) => ({ ...prev, role: role as GammaTeamRole }))}
      />

      <Input
        size="lg"
        label="Gamma Job Title"
        required
        placeholder="Enter gamma job title"
        value={data.jobTitle}
        maxLength={100}
        onChange={(event) => setData((prev) => ({ ...prev, jobTitle: event.target.value }))}
      />
    </TeamMemberFields>
  );
};
